export default class{
    constructor(id, text,posi,target,num,undoStack,type,drawLines) {
    this.div = document.createElement("this.div");
    this.parent=document.getElementById(id)
    this.div.class = "makedNode";
    this.div.innerHTML = text;
    this.clicked = null;

    this.div.setAttribute("style", "border:1px solid #111;position:absolute;left:"+posi.x+"px;top:"+(posi.y-20)+"px;cursor:pointer;background-color:#ddd;");
    this.parent.appendChild(this.div);
    this.div.onclick=()=>{
        this.delNode();
        this.clicked = target.splice(num,1);
        undoStack.push({
            type:type,
            BfTar:this.clicked,
            AfTer:num,
        });
        drawLines();
    }
}
    delNode(){
        if(this.clicked==null)
    this.parent.removeChild(this.div);
    //false == すでに消されている
    }
}
